// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"3f00a7d9","871":"15f2083e"}[chunkId] + ".chunk.css";
};